export default __webpack_public_path__ + "src/assets/membership-sixmonths.3cd039befce26e4d14266e31aade7c5e.svg";